import React from "react";

import { StyledLine, DashLineContainer } from "../styled/DashLine.styled";
import { Stack } from "@mui/material";
export default function DashLine() {
  return (
    <DashLineContainer>
      <Stack direction="row" spacing={0}>
        <StyledLine width={14} data-testid="styled-line" />
        <StyledLine width={67} data-testid="styled-line" />
        <StyledLine width={14} data-testid="styled-line" />
      </Stack>
    </DashLineContainer>
  );
}
